
// ButtonNumber
export const ButtonNumberShirt = [
  { value: "KB045- WHITE PREMIUM", label: "KB045- WHITE PREMIUM" },
  { value: "KS322- WHITE THIN", label: "KS322- WHITE THIN" },
  { value: "KB119", label: "KB119" },
  { value: "KB120", label: "KB120" },
  { value: "KB246", label: "KB246" },
  { value: "KB247", label: "KB247" },
  { value: "KB248", label: "KB248" },
  { value: "KB249", label: "KB249" },
  { value: "KB102", label: "KB102" },
  { value: "KB207", label: "KB207" },
  { value: "KB235", label: "KB235" },
  { value: "KB103", label: "KB103" },
  { value: "KB077", label: "KB077" },
  { value: "KB236", label: "KB236" },
  { value: "KB203", label: "KB203" },
  { value: "KB223", label: "KB223" },
  { value: "KB216", label: "KB216" },
  { value: "KB033", label: "KB033" },
  { value: "KB225", label: "KB225" },
  { value: "KB217", label: "KB217" },
  { value: "KB202", label: "KB202" },
  { value: "KB226", label: "KB226" },
  { value: "KB045", label: "KB045" },
  { value: "KB205", label: "KB205" },
  { value: "KB227", label: "KB227" },
  { value: "KB220", label: "KB220" },
  { value: "KB206", label: "KB206" },
  { value: "KB241", label: "KB241" },
  { value: "KB221", label: "KB221" },
  { value: "KB071", label: "KB071" },
  { value: "KB242", label: "KB242" },
  { value: "KB222", label: "KB222" },
  { value: "KB031", label: "KB031" },
  { value: "KB243", label: "KB243" },
  { value: "KB237", label: "KB237" },
  { value: "KB034", label: "KB034" },
  { value: "KB245", label: "KB245" },
  { value: "KB240", label: "KB240" },
  { value: "KG104", label: "KG104" },
  { value: "KG105", label: "KG105" },
  { value: "KG106", label: "KG106" },
  { value: "KG107", label: "KG107" },
  { value: "KCG01", label: "KCG01" },
  { value: "KCG08", label: "KCG08" },
  { value: "KCG05", label: "KCG05" },
  { value: "KCG02", label: "KCG02" },
  { value: "KCG07", label: "KCG07" },
  { value: "KCG06", label: "KCG06" },
  { value: "KCG03", label: "KCG03" },
  { value: "KCG09", label: "KCG09" },
  { value: "KCG10", label: "KCG10" },
  { value: "KTC003", label: "KTC003" },
  { value: "KTC005", label: "KTC005" },
  { value: "KTC008", label: "KTC008" },
  { value: "KTC009", label: "KTC009" },
  { value: "KYS007", label: "KYS007" },
  { value: "KYS006", label: "KYS006" },
  { value: "KS327", label: "KS327" },
  { value: "KS298", label: "KS298" },
  { value: "KS552", label: "KS552" },
  { value: "KS300", label: "KS300" },
  { value: "KS553", label: "KS553" },
  { value: "KS540", label: "KS540" },
  { value: "KS184", label: "KS184" },
  { value: "KS550", label: "KS550" },
  { value: "KS299", label: "KS299" },
  { value: "KS182", label: "KS182" },
  { value: "KS421", label: "KS421" },
  { value: "KS541", label: "KS541" },
  { value: "KS189", label: "KS189" },
  { value: "KS310", label: "KS310" },
  { value: "KS422", label: "KS422" },
  { value: "KS179", label: "KS179" },
  { value: "KS311", label: "KS311" },
  { value: "KS513", label: "KS513" },
  { value: "KS178", label: "KS178" },
  { value: "KS417", label: "KS417" },
  { value: "KS516", label: "KS516" },
  { value: "KS191", label: "KS191" },
  { value: "KS309", label: "KS309" },
  { value: "KS512", label: "KS512" },
  { value: "KS308", label: "KS308" },
  { value: "KS511", label: "KS511" },
  { value: "KS508", label: "KS508" },
  { value: "KS580", label: "KS580" },
  { value: "KSZ290", label: "KSZ290" },
  { value: "KS506", label: "KS506" },
  { value: "KS581", label: "KS581" },
  { value: "KS361", label: "KS361" },
  { value: "KS507", label: "KS507" },
  { value: "KS582", label: "KS582" },
  { value: "KS363 - NAVY", label: "KS363 - NAVY" },
  { value: "KS509", label: "KS509" },
  { value: "KS583", label: "KS583" },
  { value: "KS364", label: "KS364" },
  { value: "KS510- BLACK GLOSS", label: "KS510- BLACK GLOSS" },
  { value: "KS585", label: "KS585" },
  { value: "KS575", label: "KS575" },
  { value: "KS566", label: "KS566" },
  { value: "KS389", label: "KS389" },
  { value: "KS576", label: "KS576" },
  { value: "KS567", label: "KS567" },
  { value: "KS397", label: "KS397" },
  { value: "KS577", label: "KS577" },
  { value: "KS568", label: "KS568" },
  { value: "KS398", label: "KS398" },
  { value: "KS579", label: "KS579" },
  { value: "KS569", label: "KS569" },
  { value: "KS322", label: "KS322" },
  { value: "KS578", label: "KS578" },
  { value: "KS060", label: "KS060" },
  { value: "KS182", label: "KS182" },
  { value: "KS172", label: "KS172" },
  { value: "KS184", label: "KS184" },
  { value: "KS178", label: "KS178" },
  { value: "KS187", label: "KS187" },
  { value: "KS179", label: "KS179" },
  { value: "KS189", label: "KS189" },
  { value: "KS180", label: "KS180" },
  { value: "KS191", label: "KS191" },
  { value: "KS240", label: "KS240" },
  { value: "KS300", label: "KS300" },
  { value: "KS243", label: "KS243" },
  { value: "KS303", label: "KS303" },
  { value: "KS244", label: "KS244" },
  { value: "KS304", label: "KS304" },
  { value: "KS298", label: "KS298" },
  { value: "KS308", label: "KS308" },
  { value: "KS299", label: "KS299" },
  { value: "KS309", label: "KS309" },
  { value: "KS310", label: "KS310" },
  { value: "KS322", label: "KS322" },
  { value: "KS311", label: "KS311" },
  { value: "KS327", label: "KS327" },
  { value: "KS318", label: "KS318" },
  { value: "KS361", label: "KS361" },
  { value: "KS319 - GRAY", label: "KS319 - GRAY" },
  { value: "KS363 - NAVY", label: "KS363 - NAVY" },
  { value: "KS320- BLACK MATTE", label: "KS320- BLACK MATTE" },
  { value: "KS364", label: "KS364" },
  { value: "KS389", label: "KS389" },
  { value: "KS411", label: "KS411" },
  { value: "KS392", label: "KS392" },
  { value: "KS414", label: "KS414" },
  { value: "KS397", label: "KS397" },
  { value: "KS417", label: "KS417" },
  { value: "KS398", label: "KS398" },
  { value: "KS421", label: "KS421" },
  { value: "KS410", label: "KS410" },
  { value: "KS422", label: "KS422" },
  { value: "KS503", label: "KS503" },
  { value: "KS509", label: "KS509" },
  { value: "KS505", label: "KS505" },
  { value: "KS510", label: "KS510" },
  { value: "KS506", label: "KS506" },
  { value: "KS511", label: "KS511" },
  { value: "KS507", label: "KS507" },
  { value: "KS512", label: "KS512" },
  { value: "KS508", label: "KS508" },
  { value: "KS513", label: "KS513" },
  { value: "KS516", label: "KS516" },
  { value: "KS553", label: "KS553" },
  { value: "KS540", label: "KS540" },
  { value: "KS556", label: "KS556" },
  { value: "KS541", label: "KS541" },
  { value: "KS557", label: "KS557" },
  { value: "KS550", label: "KS550" },
  { value: "KS558", label: "KS558" },
  { value: "KS552", label: "KS552" },
  { value: "KS559", label: "KS559" },
  { value: "KS566", label: "KS566" },
  { value: "KTC005", label: "KTC005" },
  { value: "KS567", label: "KS567" },
  { value: "KTC008", label: "KTC008" },
  { value: "KS568", label: "KS568" },
  { value: "KTC009", label: "KTC009" },
  { value: "KS569", label: "KS569" },
  { value: "KB031", label: "KB031" },
  { value: "KTC003", label: "KTC003" },
  { value: "KB0033", label: "KB0033" },
  { value: "KB034", label: "KB034" },
  { value: "KB079", label: "KB079" },
  { value: "KB080", label: "KB080" },
  { value: "KB045", label: "KB045" },
  { value: "KB070", label: "KB070" },
  { value: "KB083", label: "KB083" },
  { value: "KB071", label: "KB071" },
  { value: "KB084", label: "KB084" },
  { value: "KB077", label: "KB077" },
  { value: "KB092", label: "KB092" },
  { value: "KB202", label: "KB202" },
  { value: "KB216", label: "KB216" },
  { value: "KB203", label: "KB203" },
  { value: "KB217", label: "KB217" },
  { value: "KB206", label: "KB206" },
  { value: "KB220", label: "KB220" },
  { value: "KB207", label: "KB207" },
  { value: "KB221", label: "KB221" },
  { value: "KB208", label: "KB208" },
  { value: "KB222", label: "KB222" },
  { value: "KB223", label: "KB223" },
  { value: "KB229", label: "KB229" },
  { value: "KB225", label: "KB225" },
  { value: "KB232", label: "KB232" },
  { value: "KB226", label: "KB226" },
  { value: "KB233", label: "KB233" },
  { value: "KB227", label: "KB227" },
  { value: "KB235", label: "KB235" },
  { value: "KB228", label: "KB228" },
  { value: "KB236", label: "KB236" },
  { value: "KB241", label: "KB241" },
  { value: "KB247", label: "KB247" },
  { value: "KB242", label: "KB242" },
  { value: "KB248", label: "KB248" },
  { value: "KB243", label: "KB243" },
  { value: "KB249", label: "KB249" },
  { value: "KB245", label: "KB245" },
  { value: "KB250", label: "KB250" },
  { value: "KB246", label: "KB246" },
  { value: "KB251", label: "KB251" },
  { value: "KB252", label: "KB252" },
  { value: "KJ016", label: "KJ016" },
  { value: "KB253", label: "KB253" },
  { value: "KJ017", label: "KJ017" },
  { value: "KB255", label: "KB255" },
  { value: "KJ018", label: "KJ018" },
  { value: "KB256", label: "KB256" },
  { value: "KJ020", label: "KJ020" },
  { value: "KJ013", label: "KJ013" },
  { value: "KJ021", label: "KJ021" }
];

// SatinNumbers
export const SatinNumbers = [
  { value: "DXN417A - White Grossgrain", label: "DXN417A - White Grossgrain" },
  { value: "DXN039A - Black Grossgrain", label: "DXN039A - Black Grossgrain" },
  { value: "DXN044A - Black", label: "DXN044A - Black" },
  { value: "DXN047A - Navy", label: "DXN047A - Navy" },
  { value: "DXN052A - Charcoal", label: "DXN052A - Charcoal" },
  { value: "DXN045A - White", label: "DXN045A - White" },
  { value: "DXN415A - Ivory", label: "DXN415A - Ivory" },
  { value: "DXN048A - Silver", label: "DXN048A - Silver" },
  { value: "DXN031A - Deep Red", label: "DXN031A - Deep Red" },
  { value: "DXN030A - Dark Red", label: "DXN030A - Dark Red" },
  { value: "DXN049A - Red", label: "DXN049A - Red" },
];

// LiningNumbers (loaded from /api/linings at runtime)
export const LiningNumbers = [];

// Fabrics
export const Fabrics = [];

// ButtonNumber
export const ButtonNumber = [
  { value: "KSZ153 Black Premium", label: "KSZ153 Black Premium" },
  { value: "KSZ155 White Premium", label: "KSZ155 White Premium" },
  { value: "KSZ152 Gray Premium", label: "KSZ152 Gray Premium" },
  { value: "KSZ151  Brown Premium", label: "KSZ151  Brown Premium" },
  { value: "KSZ154 Navy Premium", label: "KSZ154 Navy Premium" },
  { value: "KSZ133", label: "KSZ133" },
  { value: "KSZ134", label: "KSZ134" },
  { value: "KSZ193", label: "KSZ193" },
  { value: "KSZ195", label: "KSZ195" },
  { value: "KSZ165", label: "KSZ165" },
  { value: "KSZ196", label: "KSZ196" },
  { value: "KSZ198", label: "KSZ198" },
  { value: "KSZ197", label: "KSZ197" },
  { value: "KSZ199", label: "KSZ199" },
  { value: "KSZ176", label: "KSZ176" },
  { value: "KSZ137", label: "KSZ137" },
  { value: "KSZ138", label: "KSZ138" },
  { value: "KSZ139", label: "KSZ139" },
  { value: "KSZ140", label: "KSZ140" },
  { value: "KSZ177", label: "KSZ177" },
  { value: "KSZ220", label: "KSZ220" },
  { value: "KSZ221", label: "KSZ221" },
  { value: "KG202", label: "KG202" },
  { value: "KG203", label: "KG203" },
  { value: "KG204", label: "KG204" },
  { value: "KG168", label: "KG168" },
  { value: "KG056", label: "KG056" },
  { value: "KG064", label: "KG064" },
  { value: "KG062", label: "KG062" },
  { value: "KG053", label: "KG053" },
  { value: "KG055", label: "KG055" },
  { value: "KG069", label: "KG069" },
  { value: "KG057", label: "KG057" },
  { value: "KG054", label: "KG054" },
  { value: "KG178", label: "KG178" },
  { value: "KG068", label: "KG068" },
  { value: "KG024", label: "KG024" },
  { value: "KG157", label: "KG157" },
  { value: "KGX027", label: "KGX027" },
  { value: "KGX032", label: "KGX032" },
  { value: "KG197", label: "KG197" },
  { value: "KG198", label: "KG198" },
  { value: "KG199", label: "KG199" },
  { value: "KG196", label: "KG196" },
  { value: "KG195", label: "KG195" },
  { value: "KG212", label: "KG212" },
  { value: "KG191", label: "KG191" },
  { value: "KG190", label: "KG190" },
  { value: "KG192", label: "KG192" },
  { value: "KG206", label: "KG206" },
  { value: "KQ022", label: "KQ022" },
  { value: "KSZ191", label: "KSZ191" },
  { value: "KSZ192", label: "KSZ192" },
  { value: "KSZ205", label: "KSZ205" },
  { value: "KSZ206", label: "KSZ206" },
  { value: "KSZ207", label: "KSZ207" },
  { value: "KSZ200", label: "KSZ200" },
  { value: "KSZ201", label: "KSZ201" },
  { value: "KSZ161", label: "KSZ161" },
  { value: "KSZ162", label: "KSZ162" },
  { value: "KSZ150", label: "KSZ150" },
  { value: "KNJ039", label: "KNJ039" },
  { value: "KNJ012", label: "KNJ012" },
  { value: "KNJ011", label: "KNJ011" },
  { value: "KNJ036", label: "KNJ036" },
  { value: "KNJ030", label: "KNJ030" },
  { value: "KNJ031", label: "KNJ031" },
  { value: "KNJ033", label: "KNJ033" },
  { value: "KNJ023", label: "KNJ023" },
  { value: "KNJ024", label: "KNJ024" },
  { value: "KNJ014", label: "KNJ014" },
  { value: "KNJ013", label: "KNJ013" },
  { value: "KB020", label: "KB020" },
  { value: "KB021", label: "KB021" },
  { value: "KB022", label: "KB022" },
  { value: "KB023", label: "KB023" },
  { value: "KB025", label: "KB025" },
  { value: "KB026", label: "KB026" },
  { value: "KB027", label: "KB027" },
  { value: "KB028", label: "KB028" },
  { value: "KB029", label: "KB029" },
  { value: "KB030", label: "KB030" },
  { value: "KB002", label: "KB002" },
  { value: "KB016", label: "KB016" },
  { value: "KB008", label: "KB008" },
  { value: "KB001", label: "KB001" },
  { value: "KB010", label: "KB010" },
  { value: "KB011", label: "KB011" },
  { value: "KW063", label: "KW063" },
  { value: "KW065", label: "KW065" },
  { value: "KW067", label: "KW067" },
  { value: "KW066", label: "KW066" },
  { value: "KW068", label: "KW068" },
  { value: "KW043", label: "KW043" },
  { value: "KW017", label: "KW017" },
  { value: "KW042", label: "KW042" },
  { value: "KSZ175", label: "KSZ175" },
  { value: "KW044", label: "KW044" },
  { value: "KW006", label: "KW006" },
  { value: "KW004", label: "KW004" },
  { value: "KW045", label: "KW045" },
  { value: "KW002", label: "KW002" },
  { value: "KW003", label: "KW003" },
  { value: "KW005", label: "KW005" },
  { value: "KW071", label: "KW071" },
  { value: "KW069", label: "KW069" },
  { value: "KW070", label: "KW070" },
  { value: "KW001", label: "KW001" }
];

export const threadContrastColor = [
  { value: "C2740 Ivory", label: "C2740 Ivory" },
  { value: "C1740 White", label: "C1740 White" },
  { value: "C9114 Silvery Gray", label: "C9114 Silvery Gray" },
  { value: "C9631 Light Gray", label: "C9631 Light Gray" },
  { value: "C9623 Medium Gray", label: "C9623 Medium Gray" },
  { value: "C9666 Grey", label: "C9666 Grey" },
  { value: "C9949 Dark Grey", label: "C9949 Dark Grey" },
  { value: "C9313 Charcoal", label: "C9313 Charcoal" },
  { value: "C7292 Light Blue", label: "C7292 Light Blue" },
  { value: "C7201 Blue", label: "C7201 Blue" },
  { value: "C6935 Turquoise", label: "C6935 Turquoise" },
  { value: "C7305 Royal Blue", label: "C7305 Royal Blue" },
  { value: "C4987 Sapphire Blue", label: "C4987 Sapphire Blue" },
  { value: "C7930 Navy", label: "C7930 Navy" },
  { value: "C7978 Dark Navy", label: "C7978 Dark Navy" },
  { value: "C9770 Black", label: "C9770 Black" },
  { value: "C1172 Light Yellow", label: "C1172 Light Yellow" },
  { value: "C1231 Yellow", label: "C1231 Yellow" },
  { value: "C1257 Medium Yellow", label: "C1257 Medium Yellow" },
  { value: "C1202 Bright Yellow", label: "C1202 Bright Yellow" },
  { value: "C1424 Gold Yellow", label: "C1424 Gold Yellow" },
  { value: "C2427 Orange", label: "C2427 Orange" },
  { value: "C2376 Tan", label: "C2376 Tan" },
  { value: "C8501 Brown", label: "C8501 Brown" },
  { value: "C3156 Light Pink", label: "C3156 Light Pink" },
  { value: "C3166 Pink", label: "C3166 Pink" },
  { value: "C3646 Dark Pink", label: "C3646 Dark Pink" },
  { value: "C3867 Bright Red", label: "C3867 Bright Red" },
  { value: "C3853 Red", label: "C3853 Red" },
  { value: "C3966 Dark Red", label: "C3966 Dark Red" },
  { value: "C3993 Deep Red", label: "C3993 Deep Red" },
  { value: "C3952 Burgandy", label: "C3952 Burgandy" },
  { value: "C6178 Mint", label: "C6178 Mint" },
  { value: "C5345 Yellow Green", label: "C5345 Yellow Green" },
  { value: "C5337 Green", label: "C5337 Green" },
  { value: "C5140 Light Green", label: "C5140 Light Green" },
  { value: "C5229 Green", label: "C5229 Green" },
  { value: "C5744 Olive", label: "C5744 Olive" },
  { value: "C5987 Green", label: "C5987 Green" },
  { value: "C5943 Dark Green", label: "C5943 Dark Green" },
  { value: "C4106 Lavendar", label: "C4106 Lavendar" },
  { value: "C4328 Light Purple", label: "C4328 Light Purple" },
  { value: "C4351 Purple", label: "C4351 Purple" },
  { value: "C4300 Bright Purple", label: "C4300 Bright Purple" },
  { value: "C4983 Dark Purple", label: "C4983 Dark Purple" },
  { value: "C9313 Tan", label: "C9313 Tan" },
  { value: "C8587 Brown", label: "C8587 Brown" },
  { value: "C8989 Dark Brown", label: "C8989 Dark Brown" },
  { value: "WCG001 Multi", label: "WCG001 Multi" },
  { value: "WCG007 Multi", label: "WCG007 Multi" }
];

export const NameLabelColor = [
  { value: "102 White", label: "102 White" },
  { value: "101 Ivory", label: "101 Ivory" },
  { value: "3750 Silver Grey", label: "3750 Silver Grey" },
  { value: "3747 Light Grey", label: "3747 Light Grey" },
  { value: "3687 Medium Grey", label: "3687 Medium Grey" },
  { value: "3618 Grey", label: "3618 Grey" },
  { value: "489 Dark Grey", label: "489 Dark Grey" },
  { value: "3655 Grey Navy", label: "3655 Grey Navy" },
  { value: "432 Light Blue", label: "432 Light Blue" },
  { value: "599 Blue", label: "599 Blue" },
  { value: "1059 Turquoise", label: "1059 Turquoise" },
  { value: "455 Royal Blue", label: "455 Royal Blue" },
  { value: "1203 Sapphire Blue", label: "1203 Sapphire Blue" },
  { value: "3712 Navy Blue", label: "3712 Navy Blue" },
  { value: "3720 Navy Blue Grey", label: "3720 Navy Blue Grey" },
  { value: "103 Black", label: "103 Black" },
  { value: "352 White Yellow", label: "352 White Yellow" },
  { value: "1017 Yellow", label: "1017 Yellow" },
  { value: "3077 Medium Yellow", label: "3077 Medium Yellow" },
  { value: "3172 Yellow", label: "3172 Yellow" },
  { value: "312 Yolk Yellow", label: "312 Yolk Yellow" },
  { value: "321 Orange", label: "321 Orange" },
  { value: "392 Khaki", label: "392 Khaki" },
  { value: "3099 Light Brown", label: "3099 Light Brown" },
  { value: "3701 Light Pink", label: "3701 Light Pink" },
  { value: "624 Pink", label: "624 Pink" },
  { value: "1034 Dark Pink", label: "1034 Dark Pink" },
  { value: "714 Bright Red", label: "714 Bright Red" },
  { value: "138 Red", label: "138 Red" },
  { value: "144 Dark Red", label: "144 Dark Red" },
  { value: "145 Burgundy", label: "145 Burgundy" },
  { value: "1196 Jujube Red", label: "1196 Jujube Red" },
  { value: "1093 Turquoise", label: "1093 Turquoise" },
  { value: "3334 Yellow Green", label: "3334 Yellow Green" },
  { value: "262 Dark Olive", label: "262 Dark Olive" },
  { value: "1116 Green", label: "1116 Green" },
  { value: "3813 Medium Green", label: "3813 Medium Green" },
  { value: "1173 Dark Olive", label: "1173 Dark Olive" },
  { value: "572 Dark Green", label: "572 Dark Green" },
  { value: "3694 Dark Green", label: "3694 Dark Green" },
  { value: "177 Light Purple", label: "177 Light Purple" },
  { value: "633 Blue Purple", label: "633 Blue Purple" },
  { value: "189 Violet", label: "189 Violet" },
  { value: "3601 Purple", label: "3601 Purple" },
  { value: "3742 Dark Purple", label: "3742 Dark Purple" },
  { value: "598 Taupe", label: "598 Taupe" },
  { value: "1161 Medium Brown", label: "1161 Medium Brown" },
  { value: "1162 Dark Brown", label: "1162 Dark Brown" },
  { value: "MG2 Gold", label: "MG2 Gold" },
  { value: "MS1 Silver", label: "MS1 Silver" }
];
